import { render } from "./main.vue?vue&type=template&id=4529d432"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=4529d432&lang=scss"

import exportComponent from "/Users/kexikui/Desktop/code/dlmk/delemick-pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__